
export const fullName = `Oluwatimilehin Oluyinka`

export const bio = `I use Data to solve Business problems`

export const profession = `Data Engineer`

export const technicalSkills = `Python | SQL | ETL`

export const about = ``;

export const description =`
It's amazing how there is still an existence of diseases that shouldn't exist, or at least should have had a cure. <br>
It is definitely not an easy task studying the replication and activities of cells and developing cures and preventive mechanisms for these infections,
but it is my dream to be among the human factors that bring solutions to these issues using Data and Biology.
And I can't wait to begin my journey in Bioinformatcs.
`